<template>
  <div>
    <loader :loading="loading"/>

    <page-header :title="`Regiões`" @back="goBack">
      <template v-slot:breadcrumbs>
        <li>Cidades</li>
        <li>Regiões</li>
      </template>
    </page-header>

    <div class="card bg-white">
      <div class="card-body p-4">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <span class="card-subtitle text-primary fw-bold">Regiões da Cidade</span>     
            </div>
            <div class="justify-content-end">  
              <button type="button" class="btn btn-primary btn-sm rounded-pill" @click.prevent="newRegion">
                <i class="la la-plus"></i>
              </button>
            </div>
          </div>
          <div class="list-group pt-4 pb-4">
            <div class="list-group-item" v-for="region in regions" :key="region.id">
              <div class="d-flex w-100 align-items-center justify-content-between pb-2">
                <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between flex-fill">
                  <div class="d-flex flex-column align-items-start">
                    <span class="text-primary fw-bold">{{ region.name }}</span>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-between">
                <div class="d-flex gap-2 flex-wrap">
                  <div v-for="neighborhood in region.neighborhoods" :key="neighborhood.id">
                    <div class="">
                      <span class="badge bg-success">{{ neighborhood.name }}</span>
                    </div>
                  </div>
                </div>
                <div class="justify-content-end">
                    <div class="btn-group">
                      <button type="button" class="btn btn-primary btn-sm dropdown-toggle"
                              data-bs-popper-config='{"strategy":"fixed"}' data-bs-toggle="dropdown">
                        Ações
                      </button>
                      <ul class="dropdown-menu">
                        <li><a class="dropdown-item" href="#" @click.prevent="$router.push(`/regioes/edit/${region.id}`)">Editar</a></li>
                        <li><a class="dropdown-item" href="#" @click.prevent="removeRegion(region.id)">Remover</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loader from "@/components/shared/loader.vue";
import PageHeader from "@/components/PageHeader.vue";
import {mask} from 'vue-the-mask'
import {mapActions, mapState} from "vuex";
import {email, required, requiredIf, url} from "vuelidate/lib/validators";
import {cnpj, cpf} from 'cpf-cnpj-validator';
import axios from "axios";

export default {
  name: 'regions',
  components: {PageHeader, Loader},
  props: {},
  directives: {mask},
  data() {
    return {
      regions: [],
      city: null,
      loading: false,
      preview: null,
      previewWatermark: null,
      document_unique: true,
      payload: {
        person_type: 'J',
        document: null,
        name: null,
        zip_code: null,
        uf: null,
        city: null,
        address: null,
        number: null,
        neighborhood: null,
        email: null,
        logo_url: null,
        watermark_url: null,
        website: null,
        userName: null,
        userEmail: null,
        whatsapp: null,
        phone: null,
        external_id: null,
        complement: null,
        total_properties: null,
        unlimited: false,
        creci: null,
        status: null,
        highlights: {
          launch: null,
          sale: null,
          rental: null,
          season: null
        },
        super_highlights: {
          launch: null,
          sale: null,
          rental: null,
          season: null
        }
      }
    }
  },
  validations() {
    return {}
  },
  async mounted() {
    if (this.$route.params.id) {
      await axios.get(`/admin/city-regions/${this.$route.params.id}`).then((response) => {
        this.regions = response.data;
      });
    }
  },
  computed: {
    ...mapState('Locations', ['states']),
  },
  methods: {
    ...mapActions('Locations', ['getAddressByCep']),
    ...mapActions('Clients', ['getOneById', 'save']),
    async removeRegion(id) {
      const result = await this.$swal.fire({
        title: 'Atenção!',
        text: 'Você tem certeza que deseja remover esta região?',
        showDenyButton: true,
        confirmButtonText: 'Sim',
        denyButtonText: 'Não',
        allowOutsideClick: false
      });

      if (result.isConfirmed) {
        this.loading = true;
        try {
          await axios.delete(`/admin/city-region/${id}`);

          this.regions = this.regions.filter(region => region.id !== id);

          if (this.regions.length < 1) {
            this.$router.push(`/regioes`);
          }
        } catch (error) {
          this.$swal.fire({
            text: error.response.status === 409 ? 'Não é possível excluir a região porque ela está vinculada a imóveis ou condomínios.' : 'Houve um erro ao remover a região.',
            icon: 'error'
          });
        } finally {
          this.loading = false;
        }
      }
    },
    goBack() {
      window.history.back();
    },
    newRegion() {
      if(this.regions.length > 0) {
        const region = this.regions[0];
        this.$router.push({ path: `/regioes/edit/${region.id}`, query: { noRegion: true } });
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
